export default __webpack_public_path__ + "static/media/AMNH_02.8877fd42.png";